import { createDuck } from '@/utils/'

import { getSellPageInfo } from '@/services/api/wish'

//新人活动
export const duck = createDuck({
  name: 'wishGoodsDuck',
  initialState: {
    loading: 0,
    goods1: [],
    goods2: [],
    curTab: 1,
  },
  actions: {
    fetchSellInfo() {
      return async dispatch => {
        //getSellPageInfo
        const { data } = await getSellPageInfo()
        if (data) {
          const { subItemShowRuleList, subItemInfoList } = data
          if (!Array.isArray(subItemShowRuleList) || subItemShowRuleList.length < 2) return
          const { subItemIds: ids1 } = subItemShowRuleList[0]
          const { subItemIds: ids2 } = subItemShowRuleList[1]
          const obj = {}
          subItemInfoList.forEach((item, index) => {
            obj[item.subItemId] = index
          })
          const goods1 = ids1.split(',').map(id => {
            return { ...subItemInfoList[obj[id]] }
          })
          const goods2 = ids2.split(',').map(id => {
            return { ...subItemInfoList[obj[id]] }
          })
          dispatch(duck.change({ goods1, goods2, loading: 1 }))
        }
      }
    },
    changeTab(val) {
      return async dispatch => {
        dispatch(
          duck.change({
            curTab: val,
          }),
        )
      }
    },
  },
})
